// Tea 5.0 版本不支持函数调用 服务商平台误安装了 5.0 的 Tea 版本，暂时 Hot Fix
const TeaInstance = typeof window.Tea === 'function' ? window.Tea : undefined;

export const reportClickBanner = ({
  banner_id,
  pic_link,
  post_link,
  label,
  serial,
  post_title,
}: Record<string, unknown>) => {
  TeaInstance?.('click_banner', {
    banner_id,
    pic_link,
    post_link,
    label,
    serial,
    post_title,
  });
};

export const reportCreateComment = ({
  post_id,
  comment_id,
  uid,
  to_uid,
}: Record<string, unknown>) => {
  TeaInstance?.('create_comment', {
    post_id,
    comment_id,
    uid,
    to_uid,
  });
};

export const reportCreateReply = ({
  post_id,
  comment_id,
  uid,
  to_uid,
  reply_id,
}: Record<string, unknown>) => {
  TeaInstance?.('create_reply', {
    post_id,
    comment_id,
    uid,
    to_uid,
    reply_id,
  });
};

export const reportInit = ({
  app_id,
  channel = 'cn',
  autotrack = false,
}: Record<string, unknown>) => {
  TeaInstance?.('init', {
    app_id,
    channel,
    autotrack, // 默认关闭，需要热力图及圈选功能可开启
  });
};

export const reportStart = () => {
  TeaInstance?.('start');
};

export const reportQuerySearch = () => {
  TeaInstance?.('query-search');
};

export const reportViewNotification = () => {
  TeaInstance?.('view_notification');
};

export const reportViewPost = ({
  post_id,
  uid,
  post_type,
}: Record<string, unknown>) => {
  TeaInstance?.('view_post', {
    post_id,
    uid,
    post_type,
  });
};

export const reportCreatePost = ({
  post_id,
  uid,
  post_type,
}: Record<string, unknown>) => {
  TeaInstance?.('create_post', {
    post_id,
    uid,
    post_type,
  });
};

export const reportConfig = ({ user_unique_id }: Record<string, unknown>) => {
  TeaInstance?.('config', {
    user_unique_id,
  });
};
